module.exports = __webpack_public_path__ + "img/17.4aac76a9.png";